import { ApiError } from "@/core/api/errors";
import { IdentityError } from "@/core/auth/identity";
import { log } from "@/core/log";

/** What went wrong, in words for people; nothing for a popup the user closed. */
export function signInMessage(error: unknown): string | null {
  if (error instanceof IdentityError) return error.reason === "cancelled" ? null : error.message;
  if (error instanceof ApiError) {
    return error.status === 401 ? "Your sign-in took too long. Please sign in again." : error.message;
  }
  log.warn("Sign-in failed", error);
  return "Sign-in didn't work. Please try again.";
}
